angular.module('rentalListingModule').component('rentalListingInquiriesOptions', {
	templateUrl: 'rentalListingInquiriesOptions/rentalListingInquiriesOptions.html',
	bindings: {
		form: '<',
		user: '<',
		listing: '<',
		isMobile: '<',
		errorMessages: '<',
	},
	controller: ['$http', function($http) {
		this.setInquiriesBy = function(method, $event) {
			$event && $event.preventDefault();
			if (method) {
				this.user.sendInquiriesBy = method;
			}
		};
	}]
});
